import { render } from "./reviewTasksList.vue?vue&type=template&id=0ddef1f3&scoped=true"
import script from "./reviewTasksList.vue?vue&type=script&lang=js"
export * from "./reviewTasksList.vue?vue&type=script&lang=js"

import "./reviewTasksList.vue?vue&type=style&index=0&id=0ddef1f3&scoped=true&lang=scss"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ddef1f3"]])

export default __exports__